module.exports = __webpack_public_path__ + "img/invitation.47a7d565.svg";